import React, { useContext, useEffect } from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import {
  ConfigurationEmailConfirmationView,
  PageInConstructionView,
  VerifyContractView,
} from "../components/views";
import {
  BranchOfficeAction,
  OfferAction,
  PublicityAction,
  SurveyAction,
  ProfileAction,
  ConfigurationDomainsAction,
  ChangePasswordEmailAction,
  BusinessAdministrationAction,
  CustomizationAction,
  ClientsDashboardAction,
  ClientsDashboardProfileAction,
  BranchOfficeDetailsAction,
  ClientsDashboardTicketAction,
  UploadMultiple,
  ClientProfileAction,
  AddPublicityAction,
  AddOfferAction,
  AddSurveyAction,
  PublicityDetailsAction,
  OfferDetailsAction,
  ReportsAndStatisticsAction,
  SurveyDetailsAction,
  UserAdministrationNewAction,
  SurveyAnswersAction
} from "../components/actions";

import { Dialog } from "@progress/kendo-react-dialogs";
import { Cancel } from "../assets/logos/icons";
import { useTranslation } from "react-i18next";
import { Context } from "../Context";

/**
 *
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const MyRoute = (props) => {
  const { setAllowedActions } = useContext(Context);
  let modules = localStorage.getItem("modules");

  useEffect(() => {
    const currentModule = modules.find(module => module.path === props.path)
    if (!currentModule) return;

    const actions = currentModule.moduleRoles && currentModule.moduleRoles.length ? currentModule.moduleRoles[0].actions : null
    setAllowedActions(actions)
  }, [modules, props.path, setAllowedActions])

  modules = JSON.parse(modules);
  if (!modules || modules.length <= 0) return false;

  let validPath = false;
  for (let i = 0; i < modules.length; i++) {
    if (modules[i].path === props.path) {
      validPath = true;
      break
    }
  }
  return validPath === true ? <Route {...props} /> : null;
};


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const Routes = (props) => {
  const { t } = useTranslation();
  const { onInvitedRedirectRegister } = props;

  return (
    <React.Fragment>
      <Router>
        <Switch>
          <MyRoute
            exact={true}
            path="/change-password-user"
            component={ChangePasswordEmailAction}
          />
          <MyRoute
            exact={true}
            path="/"
            render={() => (
              <ClientsDashboardAction />
            )}
          />
          <MyRoute
            exact={true}
            path="/clients-dashboard/:userId"
            component={ClientsDashboardProfileAction}
          />
          <MyRoute
            exact={true}
            path="/client-profile"
            component={ClientProfileAction}
          />
          <MyRoute
            exact={true}
            path="/clients-dashboard/ticket/:ticketId"
            component={ClientsDashboardTicketAction}
          />
          <MyRoute
            exact={true}
            path="/profile"
            render={() => (
              <ProfileAction
                {...props}
                onInvitedRedirectRegister={onInvitedRedirectRegister}
                reloadProfileImage={props.reloadProfileImage}
              />
            )}
          />
          <MyRoute
            exact={true}
            path="/offers"
            component={OfferAction}
          />
          <MyRoute
            exact={true}
            path="/publicity"
            component={PublicityAction}
          />
          <MyRoute
            exact={true}
            path="/publicity-details"
            component={PublicityDetailsAction}
          />
          <MyRoute
            exact={true}
            path="/add-publicity"
            component={AddPublicityAction}
          />
          <MyRoute
            exact={true}
            path="/add-publicity-catalog"
            component={PublicityAction}
          />
          <MyRoute
            exact={true}
            path="/surveys"
            component={SurveyAction}
          />
          <MyRoute
            exact={true}
            path="/confirmation"
            component={ConfigurationEmailConfirmationView}
          />
          <MyRoute
            exact={true}
            path="/page-in-construction"
            component={PageInConstructionView}
          />
          <MyRoute
            exact={true}
            path="/waiting-authorization"
            component={VerifyContractView}
          />
          <MyRoute
            exact={true}
            path="/configuration-domain"
            component={ConfigurationDomainsAction}
          />
          <MyRoute
            exact={true}
            path="/branch-offices-administration"
            component={BranchOfficeAction}
          />
          <MyRoute
            exact={true}
            path="/user-administration"
            component={UserAdministrationNewAction}
          />
          <MyRoute
            exact={true}
            path="/business-administration"
            component={BusinessAdministrationAction}
          />
          <MyRoute
            exact={true}
            path="/customization"
            render={() => (
              <CustomizationAction
                reloadLogo={props.reloadLogo}
              />
            )}
          />
          <MyRoute
            exact={true}
            path="/branch-office-details"
            component={BranchOfficeDetailsAction}
          />
          <MyRoute
            exact={true}
            path="/create-branch-offices"
            component={UploadMultiple}
          />
          <MyRoute
            exact={true}
            path="/create-offers"
            component={UploadMultiple}
          />
          <MyRoute
            exact={true}
            path="/create-publicities"
            component={UploadMultiple}
          />
          <MyRoute
            exact={true}
            path="/add-offer"
            component={AddOfferAction}
          />
          <MyRoute
            exact={true}
            path="/add-survey"
            component={AddSurveyAction}
          />
          <MyRoute
            exact={true}
            path="/offer-details"
            component={OfferDetailsAction}
          />
          <MyRoute
            exact={true}
            path="/reports"
            component={ReportsAndStatisticsAction}
          />
          <MyRoute
            exact={true}
            path="/survey-details"
            component={SurveyDetailsAction}
          />
          <MyRoute
            exact={true}
            path="/survey-answers/:surveyId"
            component={SurveyAnswersAction}
          />
        </Switch>
      </Router>
      {props.showError && (
        <Dialog
          title={"govo.legal"}
          onClose={() => props.setShowError(false)}
          width={256}
          height={280}
        >
          <p
            style={{
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            <img
              alt=""
              src={Cancel}
              style={{ marginTop: "10px", width: "55px", height: "55px" }}
            />
          </p>
          <p
            style={{
              textAlign: "center",
              margin: "auto",
              maxWidth: "300px",
            }}
          >
            {t("modalGlobalErrorMessage")}
          </p>
        </Dialog>
      )}
    </React.Fragment>
  );
};

export { Routes as default };
